module.exports = "/assets/data/645baff036d2211dccdacb0d28c3af45-SN6.data.json";